import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment.prod';
import { EnvironmentLoaderService } from '../services/environment-loader.service';

@Injectable()
export class AuthGuardApp {
  constructor(private envLoaderSerive: EnvironmentLoaderService) {}

  async canActivate() {
    const envjson = await this.envLoaderSerive.getEnvData();
    // console.log("canActivate");
    console.log(envjson);
//      if(environment.production){
        environment.dashboardUrl = envjson['DashboardUrl'];
        environment.teamUrl = envjson['TeamUrl'];
        environment.eventUrl = envjson['EventUrl'];
        environment.schedulerDashboardUrl = envjson['SchedulerDashboardUrl'];
        environment.profileUrl = envjson['ProfileUrl'];
        environment.loggedUserDetailsUrl = envjson['LoggedUserDetailsUrl'];
        environment.chatUrl = envjson['ChatUrl'];
        environment.type = envjson['Type'];
        environment.eventCandidateDataUrl  = envjson['EventCandidateDataUrl'];
        environment.activityUrl = envjson['ActivityUrl'];
        environment.dashboardCandidateListUrl = envjson["DashboardCandidateListUrl"]
        environment.validationUrl = envjson['ValidationUrl'];
        environment.createCandidateUrl = envjson['CreateCandidateUrl'];
        environment.offerDBUrl = envjson['OfferDBUrl'];
        environment.recruiterUrl = envjson['RecruiterUrl'];
        environment.recruiterUrl2 = envjson['RecruiterUrl2'];
        environment.recruiterGenUrl = envjson['RecruiterGenUrl'];
        environment.recruiterPanelistUrl = envjson['RecruiterPanelistUrl'];
        environment.mongoApiUrl = envjson['MongoApiUrl'];
        environment.ExcelApiUrl = envjson['ExcelApiUrl'];
        environment.AdminUrl = envjson['AdminUrl'],
        environment.recruiterdashboardUrl = envjson['RecruiterdashboardUrl'];
        environment.publicationUrl = envjson['PublicationUrl'];
        environment.mailerServiceUrl=envjson['MailerServiceUrl'];
        environment.confirmationActivityUrl=envjson['ConfirmationActivityUrl'];
        environment.parserUrl=envjson['ParserUrl'];
        environment.offerTest=envjson['OfferTest'];
        environment.offerWF=envjson['OfferWF'];
        environment.supportEmpUrl = envjson['SupportEmpUrl'];
        environment.careerUrl = envjson['CareerUrl'];
        environment.rehireUrl = envjson['RehireUrl']
        environment.parserResumeUrl = envjson['ParserResumeUrl'];
        environment.candidateHiringNameUrl = envjson['CandidateHiringNameUrl'];
        environment.genericApiUrl = envjson['GenericApiUrl'];
        environment.bulkUploadApi = envjson['BulkUploadApi'];
        environment.elasticUrl = envjson['ElasticUrl'];
        environment.candidateSearchUrl = envjson['CandidateSearchUrl'];
        environment.tncNewUrl = envjson['TnCNewUrl'];
        environment.docUrl = envjson['DocUrl'];
        environment.resumePushUrl = envjson['ResumePushUrl'];
        environment.genModelUrl = envjson['GenModelUrl'];
        environment.marqueeEnabled = envjson['marqueeEnabled'];
        environment.marqueeMsg = envjson['marqueeMsg'];
        environment.hideIBPMJB = envjson['hideIBPMJB'];
        window["hideIBPMJB"] = JSON.parse(envjson['hideIBPMJB']);
        environment.maintenanceMode = envjson['maintenanceMode'];
        environment.veriFace = envjson['veriFace'];
        environment.hideShareButton = envjson['hideShareButton'];
        
        // Set veriFace on window object for global access
        (window as any).env = {
          veriFace: envjson['veriFace']
        };
        //set hideShareButton on window object for global access after converting to json boolean
        (window as any).env.hideShareButton = JSON.parse(envjson['hideShareButton']);
         console.log(environment.offerDBUrl);
  //     }
    console.log('auth gurad', envjson);
    //      if(environment.production){
    environment.dashboardUrl = envjson['DashboardUrl'];
    environment.teamUrl = envjson['TeamUrl'];
    environment.eventUrl = envjson['EventUrl'];
    environment.schedulerDashboardUrl = envjson['SchedulerDashboardUrl'];
    environment.profileUrl = envjson['ProfileUrl'];
    environment.loggedUserDetailsUrl = envjson['LoggedUserDetailsUrl'];
    environment.chatUrl = envjson['ChatUrl'];
    environment.type = envjson['Type'];
    environment.eventCandidateDataUrl = envjson['EventCandidateDataUrl'];
    environment.activityUrl = envjson['ActivityUrl'];
    environment.dashboardCandidateListUrl = envjson['DashboardCandidateListUrl'];
    environment.validationUrl = envjson['ValidationUrl'];
    environment.createCandidateUrl = envjson['CreateCandidateUrl'];
    environment.offerDBUrl = envjson['OfferDBUrl'];
    environment.recruiterUrl = envjson['RecruiterUrl'];
    environment.recruiterUrl2 = envjson['RecruiterUrl2'];
    environment.recruiterGenUrl = envjson['RecruiterGenUrl'];
    environment.recruiterPanelistUrl = envjson['RecruiterPanelistUrl'];
    environment.mongoApiUrl = envjson['MongoApiUrl'];
    environment.ExcelApiUrl = envjson['ExcelApiUrl'];
    environment.AdminUrl = envjson['AdminUrl'];
    environment.recruiterdashboardUrl = envjson['RecruiterdashboardUrl'];
    environment.publicationUrl = envjson['PublicationUrl'];
    environment.mailerServiceUrl = envjson['MailerServiceUrl'];
    environment.confirmationActivityUrl = envjson['ConfirmationActivityUrl'];
    environment.parserUrl = envjson['ParserUrl'];
    environment.offerTest = envjson['OfferTest'];
    environment.offerWF = envjson['OfferWF'];
    environment.supportEmpUrl = envjson['SupportEmpUrl'];
    environment.careerUrl = envjson['CareerUrl'];
    environment.rehireUrl = envjson['RehireUrl'];
    environment.parserResumeUrl = envjson['ParserResumeUrl'];
    environment.candidateHiringNameUrl = envjson['CandidateHiringNameUrl'];
    environment.genericApiUrl = envjson['GenericApiUrl'];
    environment.bulkUploadApi = envjson['BulkUploadApi'];
    environment.candidateSearchUrl = envjson['CandidateSearchUrl'];
    environment.tncNewUrl = envjson['TnCNewUrl'];
    environment.docUrl = envjson['DocUrl'];
    environment.resumePushUrl = envjson['ResumePushUrl'];
    environment.genModelUrl = envjson['GenModelUrl'];
    environment.marqueeEnabled = envjson['marqueeEnabled'];
    environment.marqueeMsg = envjson['marqueeMsg'];
    environment.hideIBPMJB = envjson['hideIBPMJB'];
    window['hideIBPMJB'] = JSON.parse(envjson['hideIBPMJB']);
    environment.maintenanceMode = envjson['maintenanceMode'];
    environment.veriFace = envjson['veriFace'];
    environment.hideShareButton = envjson['hideShareButton'];

    // Set veriFace on window object for global access
    (window as any).env = {
      veriFace: envjson['veriFace'],
    };
    //set hideShareButton on window object for global access after converting to json boolean
    (window as any).env.hideShareButton = JSON.parse(envjson['hideShareButton']);
    console.log(environment.offerDBUrl);
    //     }
    return true;
  }
}
